export default __webpack_public_path__ + "assets/icons/eye-open.bd534f38.svg";